import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import Dialog, { DialogFooter, DialogType, ResponsiveMode } from 'office-ui-fabric-react/lib/Dialog';
import { Dropdown, IDropdown, IDropdownOption } from 'office-ui-fabric-react/lib/Dropdown';
import { initializeIcons } from 'office-ui-fabric-react/lib/Icons';
import { ComboBox, IComboBoxProps, Link, Spinner, TextField } from 'office-ui-fabric-react/lib/index';
import { IStackTokens, Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyles } from 'office-ui-fabric-react/lib/Styling';
import * as React from 'react';
import { Label } from 'reactstrap';
import { IModalDialog } from '../../../models/IModalDialog';
import { IPTONames } from '../../../models/IPTONames';
import { ITechnicalCompetence } from '../../../models/ITechnicalCompetence';
import ConnectionContext from '../../../utils/ConnectionContext';
import DateUtils from '../../../utils/DateUtils';
import ExtraTerms from '../Terms/ExtraTerms';
import { ITermsServicesProps } from './ITermsServicesProps';
import { ITermsServicesState } from './ITermsServicesState';
initializeIcons();

const textbox = mergeStyles({
    display: "inline-block",
    minWidth: '50px'
});
const textboxS = mergeStyles({
    display: "inline-block",
    minWidth: '50px'
});
const panel = mergeStyles({
    display: 'block',
    background: '#ffffff',
    boxShadow: '0px 0px 5px 5px #C9C9C9',
    minHeight: '100px',
    padding: '10px',
    minWidth: '200px',
    width: "100%", fontSize: "12px", color: '#005269'
});
const invisbleButton = mergeStyles({
    display: "none",
    backgroundColor: '#35AFD1'
});
const today: Date = new Date(Date.now());
const tableTechnical = mergeStyles({
    display: "table",
    margin: '0 auto',
    width: "100%",
    verticalAlign: "bottom",
    padding: "5px"
});
const panelDisabled = mergeStyles({
    display: 'block',
    boxShadow: '0px 0px 5px 5px #C9C9C9',
    minHeight: '100px',
    padding: '10px',
    minWidth: '200px',
    width: "100%",
    fontSize: "12px",
    color: '#005269',
    pointerEvents: "none"
});
const responsiveMain = mergeStyles({
    margin: "0px auto",
    overflowX: "auto"
});
const responsiveTable = mergeStyles({
    display: "table",
    margin: '0 auto',
    width: "100%",
    tableLayout: "fixed"
});
const responsiveTableRow = mergeStyles({
    display: "table-row",
    border: "1px solid #005269"
});
const responsiveTableBody = mergeStyles({
    display: "table-row-group"
});
const responsiveTableBodyCell = mergeStyles({
    display: "table-cell", fontSize: '12px', padding: "2px"
});
const responsiveTableBodyCaption = mergeStyles({
    width: "100%", overflow: "auto", fontSize: '13px', background: '#E5E5E5', padding: "5px"
});
const responsiveTableBodyCellText = mergeStyles({
    width: "100%", overflow: "auto", alignContent: 'justify', padding: "5px"
});
const textboxWithDropdown = mergeStyles({
    display: "inline-block",
    marginRight: "5px"
});
const alertMsgPanel = mergeStyles({
    color: "#E9512D", fontSize: "13px", textAlign: "left"
});
const checkBoxTermsPanel = mergeStyles({
    width: "100%", fontSize: '13px', background: '#E5E5E5', padding: "5px", display: "inline-block", verticalAlign: "top", position: "relative"
});
const checkBoxTerms = mergeStyles({
    position: "relative", top: "2px", marginRight: "2px"
});
const submitButton = mergeStyles({ backgroundColor: '#F39000', marginRight: "5px" });
const cancelButton = mergeStyles({ backgroundColor: '#E9512D', marginRight: "5px" });
const submitButtonAlignment = mergeStyles({ textAlign: "center", margin: "0 auto" });
const addButton = mergeStyles({ backgroundColor: '#35AFD1', marginRight: "5px" });
const dropdownStyle = mergeStyles({ minWidth: '150px', fontSize: "12px" });
export default class TermsServices extends React.Component<ITermsServicesProps, ITermsServicesState>
{
    private connectionContext: ConnectionContext;
    private dialog: IModalDialog;
    private EmployeeError: string;
    private PatentAttorneyError: string;
    private TrademarkAttorneyError: string;
    private LawAttorneyError: string;
    private ResidentPatentError: string;
    private PatentApplicationError: string;
    private ResidentTrademarkError: string;
    private TrademarkapplicationsError: string;
    private TrademarkProsecutionError: string;
    private PatentProsecutionError: string;
    private RewardError: string;
    private InsuranceError: string;
    private InsuranceAmountError: string;
    private InsuranceCurrencyError: string;
    private AnnualAggregateError: string;
    private AnnualAggregateCurrencyError: string;
    private PTOError: string;
    private QtyManagementError: string;
    private QtyManagementStandardError: string;
    private ITSecurityError: string;
    private ITSecurityStandardError: string;
    private ProfessionalConductError: string;
    private ConductCodeError: string;
    private DocketingSystemError: string;
    private BussinessTermsError: string;
    private TechnicalCompetenceError: string;
    constructor(props: ITermsServicesProps, state: ITermsServicesState) {
        super(props);
        this.connectionContext = this.props.connectionContext;
        this.EmployeeError = '';
        this.PatentAttorneyError = '';
        this.TrademarkAttorneyError = '';
        this.LawAttorneyError = '';
        this.ResidentPatentError = '';
        this.PatentApplicationError = '';
        this.ResidentTrademarkError = '';
        this.TrademarkapplicationsError = '';
        this.TrademarkProsecutionError = '';
        this.PatentProsecutionError = '';
        this.RewardError = '';
        this.InsuranceError = '';
        this.InsuranceAmountError = '';
        this.InsuranceCurrencyError = '';
        this.AnnualAggregateError = '';
        this.AnnualAggregateCurrencyError = '';
        this.PTOError = '';
        this.QtyManagementError = '';
        this.QtyManagementStandardError = '';
        this.ITSecurityError = '';
        this.ITSecurityStandardError = '';
        this.ProfessionalConductError = '';
        this.ConductCodeError = '';
        this.DocketingSystemError = '';
        this.BussinessTermsError = '';
        this.TechnicalCompetenceError = '';
        this.handleCheck = this.handleCheck.bind(this);
        this.state = {
            loading: false,
            isActive: false,
            isBussChecked: false,
            isTermsChecked: true,
            agentMaster: this.props.agentMaster,
            inputError: 'This field is required',
            showError: false,
            isValidData: true,
            saving: false,
            Currencies: [],
            terms: {
                id: undefined,
                agentId: this.props.agentMaster.id,
                employees: 0,
                trademarkAttorneys: 0,
                patentAttorneys: 0,
                lawAttorneys: 0,
                rpaLastYear: 0,
                papctLastYear: 0,
                rtaLastYear: 0,
                tamaLastYear: 0,
                tradeProsecRank: 0,
                patentProsecRank: 0,
                anyOtherAward: '',
                indemnityInsurance: '',
                iMaxAmount: 0,
                iCurrency: '',
                iAnnualAggregate: 0,
                aaCurrency: '',
                qtyMgmt: '',
                qtyMgmtStd: '',
                itSec: '',
                itSecStd: '',
                profConduct: '',
                conductCodes: '',
                docketingSystem: '',
                businessTerms: '',
                serviceTerms: false,
                ptoNames: [],
                technicalCompetenceAgent: []
            },
            user: this.props.user,
            hideModel: true,
            technicalCompetence: [],
            //ptonames: [{ id: "", agentid: "", ptoname: "" }]
            ptonames: [],
            hideDialog: true
        }
        this.dialog = {
            hideDialog: true,
            accessDeniedDialog: false,
            dialogMessage: '',
            dialogBody: '',
            mode: ''
        }
    }
    private technicalCompetence = async (): Promise<void> => {
        try {
            var result: any = [];
            let technicalCompetence: ITechnicalCompetence[] = await this.connectionContext.get("Terms");
            this.setState((prevState: ITermsServicesState): ITermsServicesState => {
                prevState.technicalCompetence = technicalCompetence;
                technicalCompetence.forEach((item: ITechnicalCompetence) => {
                    result.push({ id: undefined, agentId: this.props.agentMaster.id, title: item.title, category: item.category, selected: false });
                });
                prevState.terms.technicalCompetenceAgent = result;
                return prevState;
            });

        } catch (error) {
            this.handleError("Message", "Unable to process at the moment. Please try again or contact agent.network@zacco.com.");
        }
    }
    private handleCheck = (event) => {
        var isChecked: boolean = event.target.checked;
        this.setState((prevState: ITermsServicesState): ITermsServicesState => {
            prevState.terms.serviceTerms = isChecked;
            prevState.isTermsChecked = isChecked;
            if (isChecked && this.state.isBussChecked) {
                prevState.isActive = true;
            }
            else {
                prevState.isActive = false;
            }
            return prevState;
        });
    }
    public async componentDidMount() {
        if (this.state.agentMaster.id !== null && this.state.agentMaster.id !== undefined && this.state.agentMaster.id !== "") {
            this.loadCurrencies();
            this.setState((prevState: ITermsServicesState): ITermsServicesState => {
                if (this.props.terms.id !== "" && this.props.terms.id !== undefined && this.props.terms.id !== null) {
                    prevState.terms = this.props.terms;
                    this.props.terms.ptoNames.forEach((item: IPTONames) => {
                        prevState.ptonames.push({ id: item.id, agentId: item.agentId, ptoName: item.ptoName });
                    });
                } else {
                    this.technicalCompetence();
                    this.addPTO();
                }
                return prevState;
            });
        }
    }
    private ExtraTerms = async (): Promise<void> => {
        this.setState((previousState: ITermsServicesState): ITermsServicesState => {
            previousState.hideModel = false;
            return previousState;
        });
    }
    private onAddingItem = (item) => {
        const isChecked = item.target.checked;
        const value = item.target.value;
        this.setState((previousState: ITermsServicesState): ITermsServicesState => {
            previousState.terms.technicalCompetenceAgent.forEach((tech: any) => {
                if (tech.title === value) {
                    tech.selected = isChecked;
                }
            });
            return previousState;
        });
    }
    private addPTO = () => {
        this.setState({
            ptonames: this.state.ptonames.concat([{ id: undefined, agentId: this.props.agentMaster.id, ptoName: "" }])
        });
    }
    private removePTO = (i) => {
        this.setState({
            ptonames: this.state.ptonames.filter((s, sidx) => i !== sidx)
        });
    }
    private handlePTONameChange = async (i, event): Promise<void> => {
        var value: string = event.target.value;
        const newPTONames = this.state.ptonames.map((ptoname, sidx) => {
            if (i !== sidx) return ptoname;
            return { ...ptoname, ptoName: value };
        });

        this.setState((previousState: ITermsServicesState): ITermsServicesState => {
            previousState.ptonames = newPTONames;
            previousState.terms.ptoNames = newPTONames;
            let ptoName: boolean = previousState.ptonames.length > 0;
            previousState.ptonames.forEach((item: IPTONames) => {
                if (item.ptoName === "" || item.ptoName === undefined || item.ptoName === null) {
                    ptoName = false;
                }
            });
            if (!ptoName) {
                this.PTOError = 'Required';
            }
            else {
                this.PTOError = '';
            }
            return previousState;
        });
    };
    public render(): React.ReactElement<ITermsServicesProps> {
        const stackTokens: IStackTokens = { childrenGap: 20 };
        const dropdownRef = React.createRef<IDropdown>();
        const handleFocus = (event) => event.target.select();
        const techChemistry = this.state.terms.technicalCompetenceAgent.filter(tech => tech.category === "Chemistry").sort((a, b) => a.title > b.title ? 1 : -1);
        const techInstruments = this.state.terms.technicalCompetenceAgent.filter(tech => tech.category === "Instruments").sort((a, b) => a.title > b.title ? 1 : -1);
        const techElectricalengineering = this.state.terms.technicalCompetenceAgent.filter(tech => tech.category === "Electrical engineering").sort((a, b) => a.title > b.title ? 1 : -1);
        const techMechanicalengineering = this.state.terms.technicalCompetenceAgent.filter(tech => tech.category === "Mechanical engineering").sort((a, b) => a.title > b.title ? 1 : -1);
        let { ptonames } = this.state;
        return (
            <div className={!this.state.terms.id ? panel : panelDisabled}>
                {
                    (this.state.saving) && (
                        <div>
                            <div>
                                <Spinner label="Please wait..." />
                            </div>
                            <div>
                                <Dialog
                                    hidden={this.state.hideDialog}
                                    dialogContentProps={{
                                        type: DialogType.largeHeader,
                                        title: this.dialog.dialogMessage,
                                    }}
                                    maxWidth="1024px"
                                    closeButtonAriaLabel="Close"
                                >
                                    <div>
                                        <div>
                                            <Label> {this.dialog.dialogBody} </Label>
                                        </div>
                                    </div>
                                    <DialogFooter>
                                        <DefaultButton onClick={this.closeMessagePopup} data-automation-id="test" text="Ok" disabled={false}
                                            className={submitButton} iconProps={{ iconName: "CheckMark" }} />
                                    </DialogFooter>
                                </Dialog>

                            </div>
                        </div>)
                }
                {
                    <div>
                        <div>
                            <Dialog
                                hidden={this.state.hideModel}
                                dialogContentProps={{
                                    type: DialogType.largeHeader,
                                    title: this.dialog.dialogMessage,
                                }}
                                maxWidth="1024px"
                                closeButtonAriaLabel="Close"
                            >
                                <div>
                                    <div>
                                        <ExtraTerms connectionContext={this.connectionContext} />
                                    </div>
                                </div>
                                <DialogFooter>
                                    <DefaultButton onClick={this.acceptBusinessTerms} data-automation-id="test" text="I agree with the terms of business" disabled={false} className={submitButton} />
                                    <DefaultButton onClick={this.declineBusinessTerms} data-automation-id="test" text="Close" disabled={false} className={cancelButton} iconProps={{ iconName: "ChromeClose" }} />
                                </DialogFooter>
                            </Dialog>
                        </div>
                    </div>
                }
                {
                    (!this.state.saving) && (
                        <div>
                            <div>
                                {DateUtils.getFormatedDateWithTime(today)}
                            </div>
                            <div className={responsiveMain}>
                                <div className={responsiveTable}>
                                    <div className={responsiveTableBody}>
                                        <div className={responsiveTableBodyCaption}>PURPOSE WITH THIS PROTOCOL</div>
                                        <div className={responsiveTableBodyCellText}>Zacco strives to continuously develop and secure the quality of its foreign network of agents. The protection of our client’s rights in countries/jurisdictions where we are not present implies an increased risk to us which we want to minimize.<br />
                                            Before you move forward to insert the details of your fee for different services, it is mandatory that you shall fulfill following evaluation condition to be a Zacco Agent.
                                        </div>
                                        <div className={responsiveTableBodyCaption}>1. AGENT NAME AND COUNTRY/JURISDICTION</div>
                                        <div className={responsiveTableRow}>
                                            <div className={responsiveTableBodyCell}>
                                                <div className={responsiveTable}>
                                                    <div className={responsiveTableBody}>
                                                        <div className={responsiveTableRow}>
                                                            <div className={responsiveTableBodyCell}>Agent name</div>
                                                            <div className={responsiveTableBodyCell}>{this.state.agentMaster.firmName}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={responsiveTableRow}>
                                            <div className={responsiveTableBodyCell}>
                                                <div className={responsiveTable}>
                                                    <div className={responsiveTableBody}>
                                                        <div className={responsiveTableRow}>
                                                            <div className={responsiveTableBodyCell}>Country/Jurisdiction</div>
                                                            <div className={responsiveTableBodyCell}>{this.state.agentMaster.countryName}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={responsiveTableBodyCaption}>2.	OFFICE LOCATIONS OF YOUR FIRM</div>
                                        <div className={responsiveTableBodyCellText}>2.1 Indicate where your firm have offices in the country mentioned above under paragraph 1, and please underline your main office. If you don’t have local presence in this country, please indicate the location of the office which is intended to serve Zacco in IP-matters in this country/jurisdiction.</div>
                                        <div className={responsiveTableRow}>
                                            <div className={responsiveTableBodyCell}>
                                                <div className={responsiveTable}>
                                                    <div className={responsiveTableBody}>
                                                        <div className={responsiveTableRow}>
                                                            <div className={responsiveTableBodyCell}>City</div>
                                                            <div className={responsiveTableBodyCell}>{this.state.agentMaster.city}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={responsiveTableRow}>
                                            <div className={responsiveTableBodyCell}>
                                                <div className={responsiveTable}>
                                                    <div className={responsiveTableBody}>
                                                        <div className={responsiveTableRow}>
                                                            <div className={responsiveTableBodyCell}>Country</div>
                                                            <div className={responsiveTableBodyCell}>{this.state.agentMaster.countryName}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={responsiveTableBodyCaption}>3.	SIZE OF YOUR FIRM</div>
                                        <div className={responsiveTableBodyCellText}>3.1 Indicate the size of your firm in the country mentioned above under paragraph 1:</div>
                                        <div className={responsiveTableRow}>
                                            <div className={responsiveTableBodyCell}>
                                                <div className={responsiveTable}>
                                                    <div className={responsiveTableBody}>
                                                        <div className={responsiveTableRow}>
                                                            <div className={responsiveTableBodyCell}>Number of employees</div>
                                                            <div className={responsiveTableBodyCell}><TextField required className={textbox} value={this.state.terms.employees.toString()}
                                                                maxLength={6} onChange={this.getErrorMessageEmp} errorMessage={this.EmployeeError} onFocus={handleFocus} /></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={responsiveTableRow}>
                                            <div className={responsiveTableBodyCell}>
                                                <div className={responsiveTable}>
                                                    <div className={responsiveTableBody}>
                                                        <div className={responsiveTableRow}>
                                                            <div className={responsiveTableBodyCell}>Number of patent attorneys/agents</div>
                                                            <div className={responsiveTableBodyCell}><TextField required className={textbox} value={this.state.terms.patentAttorneys.toString()}
                                                                maxLength={6} onChange={this.getErrorMessagePA} errorMessage={this.PatentAttorneyError} onFocus={handleFocus} /></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={responsiveTableRow}>
                                            <div className={responsiveTableBodyCell}>
                                                <div className={responsiveTable}>
                                                    <div className={responsiveTableBody}>
                                                        <div className={responsiveTableRow}>
                                                            <div className={responsiveTableBodyCell}>Number of trademark attorneys/agents</div>
                                                            <div className={responsiveTableBodyCell}><TextField required className={textbox} value={this.state.terms.trademarkAttorneys.toString()}
                                                                maxLength={6} onChange={this.getErrorMessageTA} errorMessage={this.TrademarkAttorneyError} onFocus={handleFocus} /></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={responsiveTableRow}>
                                            <div className={responsiveTableBodyCell}>
                                                <div className={responsiveTable}>
                                                    <div className={responsiveTableBody}>
                                                        <div className={responsiveTableRow}>
                                                            <div className={responsiveTableBodyCell}>Number of attorneys at law</div>
                                                            <div className={responsiveTableBodyCell}><TextField required className={textbox} value={this.state.terms.lawAttorneys.toString()}
                                                                maxLength={6} onChange={this.getErrorMessageLA} errorMessage={this.LawAttorneyError} onFocus={handleFocus} /></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={responsiveTableBodyCaption}>4.	CAPACITY OF YOUR FIRM</div>
                                        <div className={responsiveTableBodyCellText}>4.1 Indicate the capacity of your firm in the country mentioned above under paragraph 1:</div>
                                        <div className={responsiveTableRow}>
                                            <div className={responsiveTableBodyCell}>
                                                <div className={responsiveTable}>
                                                    <div className={responsiveTableBody}>
                                                        <div className={responsiveTableRow}>
                                                            <div className={responsiveTableBodyCell}>National patents within your jurisdictions filed last year</div>
                                                            <div className={responsiveTableBodyCell}><TextField required className={textbox} value={this.state.terms.rpaLastYear.toString()}
                                                                maxLength={6} onChange={this.getErrorMessageRPA} errorMessage={this.ResidentPatentError} onFocus={handleFocus} /></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={responsiveTableRow}>
                                            <div className={responsiveTableBodyCell}>
                                                <div className={responsiveTable}>
                                                    <div className={responsiveTableBody}>
                                                        <div className={responsiveTableRow}>
                                                            <div className={responsiveTableBodyCell}>Patent applications filed under the PCT last year</div>
                                                            <div className={responsiveTableBodyCell}><TextField required className={textbox} value={this.state.terms.papctLastYear.toString()}
                                                                maxLength={6} onChange={this.getErrorMessagePAPCT} errorMessage={this.PatentApplicationError} onFocus={handleFocus} /></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={responsiveTableRow}>
                                            <div className={responsiveTableBodyCell}>
                                                <div className={responsiveTable}>
                                                    <div className={responsiveTableBody}>
                                                        <div className={responsiveTableRow}>
                                                            <div className={responsiveTableBodyCell}>National trademark applications within your jurisdictions filed last year</div>
                                                            <div className={responsiveTableBodyCell}><TextField required className={textbox} value={this.state.terms.rtaLastYear.toString()}
                                                                maxLength={6} onChange={this.getErrorMessageRTA} errorMessage={this.ResidentTrademarkError} onFocus={handleFocus} /></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={responsiveTableRow}>
                                            <div className={responsiveTableBodyCell}>
                                                <div className={responsiveTable}>
                                                    <div className={responsiveTableBody}>
                                                        <div className={responsiveTableRow}>
                                                            <div className={responsiveTableBodyCell}>Trademark applications filed under the Madrid Agreement last year (if applicable)</div>
                                                            <div className={responsiveTableBodyCell}><TextField required className={textbox} value={this.state.terms.tamaLastYear.toString()}
                                                                maxLength={6} onChange={this.getErrorMessageTAMA} errorMessage={this.TrademarkapplicationsError} onFocus={handleFocus} /></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={responsiveTableBodyCaption}>5.	RANKING AND REWARDS</div>
                                        <div className={responsiveTableBodyCellText}>5.1 Indicate your latest ranking according to the Managing IP magazine:</div>
                                        <div className={responsiveTableRow}>
                                            <div className={responsiveTableBodyCell}>
                                                <div className={responsiveTable}>
                                                    <div className={responsiveTableBody}>
                                                        <div className={responsiveTableRow}>
                                                            <div className={responsiveTableBodyCell}>Trademark prosecution</div>
                                                            <div className={responsiveTableBodyCell}><TextField required className={textbox} value={this.state.terms.tradeProsecRank.toString()}
                                                                maxLength={6} onChange={this.getErrorMessageTrPr} errorMessage={this.TrademarkProsecutionError} onFocus={handleFocus} /></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={responsiveTableRow}>
                                            <div className={responsiveTableBodyCell}>
                                                <div className={responsiveTable}>
                                                    <div className={responsiveTableBody}>
                                                        <div className={responsiveTableRow}>
                                                            <div className={responsiveTableBodyCell}>Patent prosecution</div>
                                                            <div className={responsiveTableBodyCell}><TextField required className={textbox} value={this.state.terms.patentProsecRank.toString()}
                                                                maxLength={6} onChange={this.getErrorMessagePPtPr} errorMessage={this.PatentProsecutionError} onFocus={handleFocus} /></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={responsiveTableRow}>
                                            <div className={responsiveTableBodyCell}>
                                                <div className={responsiveTable}>
                                                    <div className={responsiveTableBody}>
                                                        <div className={responsiveTableRow}>
                                                            <div className={responsiveTableBodyCell}>5.2 Have you received any other rewards the past year?</div>
                                                            <div className={responsiveTableBodyCell}>
                                                                <Stack tokens={stackTokens} verticalAlign="end">
                                                                    <Stack horizontal tokens={stackTokens} verticalAlign="end">
                                                                        <Dropdown
                                                                            id="ddrew"
                                                                            placeHolder="--Select--"
                                                                            componentRef={dropdownRef} responsiveMode={ResponsiveMode.large}
                                                                            options={[
                                                                                { key: 'Yes', text: 'Yes' },
                                                                                { key: 'No', text: 'No' }
                                                                            ]}
                                                                            required={true}
                                                                            styles={{ dropdown: { minWidth: 100 } }}
                                                                            onChanged={this.onChangeReward.bind(this)}
                                                                            errorMessage={this.RewardError}
                                                                            selectedKey={this.state.terms.anyOtherAward}
                                                                        />
                                                                    </Stack>
                                                                </Stack></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={responsiveTableBodyCaption}>6.	INDEMNITY INSURANCE</div>
                                        <div className={responsiveTableRow}>
                                            <div className={responsiveTableBodyCell}>
                                                <div className={responsiveTable}>
                                                    <div className={responsiveTableBody}>
                                                        <div className={responsiveTableRow}>
                                                            <div className={responsiveTableBodyCell}>Do you have indemnity insurance (with a reputable insurance company)?</div>
                                                            <div className={responsiveTableBodyCell}>
                                                                <Stack tokens={stackTokens} verticalAlign="end">
                                                                    <Stack horizontal tokens={stackTokens} verticalAlign="end">
                                                                        <Dropdown
                                                                            id="ddins"
                                                                            placeHolder="--Select--"
                                                                            componentRef={dropdownRef} responsiveMode={ResponsiveMode.large}
                                                                            options={[
                                                                                { key: 'Yes', text: 'Yes' },
                                                                                { key: 'No', text: 'No' }
                                                                            ]}
                                                                            required={true}
                                                                            styles={{ dropdown: { minWidth: 100 } }}
                                                                            onChanged={this.onChangeIns.bind(this)}
                                                                            errorMessage={this.InsuranceError}
                                                                            selectedKey={this.state.terms.indemnityInsurance}
                                                                        />
                                                                    </Stack>
                                                                </Stack></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={responsiveTableRow}>
                                            <div className={responsiveTableBodyCell}>
                                                <div className={responsiveTable}>
                                                    <div className={responsiveTableBody}>
                                                        <div className={responsiveTableRow}>
                                                            <div className={responsiveTableBodyCell}>If yes, please indicate maximum amount and currency per claim</div>
                                                            <div className={responsiveTableBodyCell}>
                                                                <div className={textboxWithDropdown}><TextField className={textbox} value={this.state.terms.iMaxAmount.toString()}
                                                                    maxLength={10} onChange={this.getErrorMessageInsAmt} errorMessage={this.InsuranceAmountError} />
                                                                </div>
                                                                <div className={textboxWithDropdown}>
                                                                    <Stack tokens={stackTokens} verticalAlign="end">
                                                                        <Stack horizontal tokens={stackTokens} verticalAlign="end">
                                                                            <ComboBox
                                                                                placeholder="-Currency--"
                                                                                allowFreeform
                                                                                autoComplete="on"
                                                                                options={this.state.Currencies}
                                                                                onChange={this.onChangeInsCur}
                                                                                errorMessage={this.InsuranceCurrencyError}
                                                                                selectedKey={this.state.terms.iCurrency}
                                                                                className={dropdownStyle}
                                                                            />
                                                                        </Stack>
                                                                    </Stack>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={responsiveTableRow}>
                                            <div className={responsiveTableBodyCell}>
                                                <div className={responsiveTable}>
                                                    <div className={responsiveTableBody}>
                                                        <div className={responsiveTableRow}>
                                                            <div className={responsiveTableBodyCell}>Annual aggregate</div>
                                                            <div className={responsiveTableBodyCell}>
                                                                <div className={textboxWithDropdown}><TextField className={textbox} value={this.state.terms.iAnnualAggregate.toString()}
                                                                    maxLength={10} onChange={this.getErrorMessageAAmt} errorMessage={this.AnnualAggregateError} />
                                                                </div>
                                                                <div className={textboxWithDropdown}>
                                                                    <Stack tokens={stackTokens} verticalAlign="end">
                                                                        <Stack horizontal tokens={stackTokens} verticalAlign="end">
                                                                            <ComboBox
                                                                                placeholder="-Currency--"
                                                                                allowFreeform
                                                                                autoComplete="on"
                                                                                options={this.state.Currencies}
                                                                                selectedKey={this.state.terms.aaCurrency}
                                                                                className={dropdownStyle}
                                                                                onChange={this.onChangeAACur}
                                                                                errorMessage={this.AnnualAggregateCurrencyError}
                                                                            />
                                                                        </Stack>
                                                                    </Stack>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={responsiveTableBodyCaption}>7.	TECHNICAL COMPETENCE</div>
                                        <div className={responsiveTableBodyCellText}>
                                            7.1 In what following areas do you have technical competencies?
                                        </div>
                                        <div className={responsiveTableRow}>
                                            <div className={responsiveTableBodyCell}>
                                                <div className={responsiveTable}>
                                                    <div className={responsiveTableRow}>
                                                        <div className={responsiveTableBodyCell}>
                                                            <div className={responsiveTableBodyCaption}>Chemistry</div>
                                                            <div className={tableTechnical}>
                                                                <div className={responsiveTableBody}>
                                                                    {
                                                                        techChemistry.map((tech, i) => {
                                                                            return (
                                                                                <div className={responsiveTableRow}>
                                                                                    <div className={responsiveTableBodyCell}>{tech.title}</div>
                                                                                    <div className={responsiveTableBodyCell}><input value={tech.title} type="checkbox" checked={tech.selected} onChange={this.onAddingItem} /></div>
                                                                                </div>
                                                                            )
                                                                        })
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className={responsiveTableBodyCell}>
                                                            <div className={responsiveTableBodyCaption}>Electrical engineering</div>
                                                            <div className={tableTechnical}>
                                                                <div className={responsiveTableBody}>
                                                                    {
                                                                        techElectricalengineering.map((tech, i) => {
                                                                            return (
                                                                                <div className={responsiveTableRow}>
                                                                                    <div className={responsiveTableBodyCell}>{tech.title}</div>
                                                                                    <div className={responsiveTableBodyCell}><input value={tech.title} type="checkbox" checked={tech.selected} onChange={this.onAddingItem} /></div>
                                                                                </div>
                                                                            )
                                                                        })
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className={responsiveTableBodyCell}>
                                                            <div className={responsiveTableBodyCaption}>Instruments</div>
                                                            <div className={tableTechnical}>
                                                                <div className={responsiveTableBody}>
                                                                    {
                                                                        techInstruments.map((tech, i) => {
                                                                            return (
                                                                                <div className={responsiveTableRow}>
                                                                                    <div className={responsiveTableBodyCell}>{tech.title}</div>
                                                                                    <div className={responsiveTableBodyCell}><input value={tech.title} type="checkbox" checked={tech.selected} onChange={this.onAddingItem} /></div>
                                                                                </div>
                                                                            )
                                                                        })
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className={responsiveTableBodyCell}>
                                                            <div className={responsiveTableBodyCaption}>Mechanical engineering</div>
                                                            <div className={tableTechnical}>
                                                                <div className={responsiveTableBody}>
                                                                    {
                                                                        techMechanicalengineering.map((tech, i) => {
                                                                            return (
                                                                                <div className={responsiveTableRow}>
                                                                                    <div className={responsiveTableBodyCell}>{tech.title}</div>
                                                                                    <div className={responsiveTableBodyCell}><input value={tech.title} type="checkbox" checked={tech.selected} onChange={this.onAddingItem} /></div>
                                                                                </div>
                                                                            )
                                                                        })
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={responsiveTableBodyCaption}>8.	REPRESENTATION</div>
                                        <div className={responsiveTableBodyCellText}>
                                            8.1 In your capacity as attorney or agent, please indicate which patent and trademark offices (PTOs) you are allowed to prosecute applications before.
                                        </div>
                                        <div className={responsiveTableRow}>
                                            <div className={responsiveTableBodyCell}>
                                                {
                                                    ptonames.map((val, idx) => {
                                                        return (
                                                            <div>
                                                                <div className={textboxWithDropdown}>
                                                                    <label> Name of the PTO #{idx + 1} </label>
                                                                </div>
                                                                <div className={textboxWithDropdown}>
                                                                    <input type="text" data-id={idx} value={val.ptoName} onChange={e => this.handlePTONameChange(idx, e)} />
                                                                    <PrimaryButton onClick={() => this.removePTO(idx)} className={idx === 0 ? invisbleButton : "small"} iconProps={{ iconName: 'Delete' }}>Remove PTO </PrimaryButton>
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                                <PrimaryButton onClick={this.addPTO} className={addButton} iconProps={{ iconName: 'Add' }}> Add New PTO </PrimaryButton>
                                                <span className={alertMsgPanel}>{this.PTOError} </span>
                                            </div>
                                        </div>
                                        <div className={responsiveTableBodyCaption}>9.	QUALITY MANAGEMENT SYSTEM</div>
                                        <div className={responsiveTableRow}>
                                            <div className={responsiveTableBodyCell}>
                                                <div className={responsiveTable}>
                                                    <div className={responsiveTableBody}>
                                                        <div className={responsiveTableRow}>
                                                            <div className={responsiveTableBodyCell}>Do you have a quality management system implemented?</div>
                                                            <div className={responsiveTableBodyCell}>
                                                                <Stack tokens={stackTokens} verticalAlign="end">
                                                                    <Stack horizontal tokens={stackTokens} verticalAlign="end">
                                                                        <Dropdown
                                                                            id="ddqty"
                                                                            placeHolder="--Select--"
                                                                            componentRef={dropdownRef} responsiveMode={ResponsiveMode.large}
                                                                            options={[
                                                                                { key: 'Yes', text: 'Yes' },
                                                                                { key: 'No', text: 'No' }
                                                                            ]}
                                                                            required={true}
                                                                            styles={{ dropdown: { minWidth: 100 } }}
                                                                            selectedKey={this.state.terms.qtyMgmt}
                                                                            onChanged={this.onChangeQtyMgmt.bind(this)}
                                                                            errorMessage={this.QtyManagementError}
                                                                        />
                                                                    </Stack>
                                                                </Stack>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={responsiveTableRow}>
                                            <div className={responsiveTableBodyCell}>
                                                <div className={responsiveTable}>
                                                    <div className={responsiveTableBody}>
                                                        <div className={responsiveTableRow}>
                                                            <div className={responsiveTableBodyCell}>If yes, which standard(s) does it comply with?</div>
                                                            <div className={responsiveTableBodyCell}>
                                                                <TextField className={textboxS} value={this.state.terms.qtyMgmtStd}
                                                                    maxLength={40} onChange={this.getErrorMessageQtyMgmtStd} errorMessage={this.QtyManagementStandardError} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={responsiveTableBodyCaption}>10.	IT &amp; INFORMATION SECURITY</div>
                                        <div className={responsiveTableRow}>
                                            <div className={responsiveTableBodyCell}>
                                                <div className={responsiveTable}>
                                                    <div className={responsiveTableBody}>
                                                        <div className={responsiveTableRow}>
                                                            <div className={responsiveTableBodyCell}>Have you implemented a structured way of working with IT &amp; information security?</div>
                                                            <div className={responsiveTableBodyCell}>
                                                                <Stack tokens={stackTokens} verticalAlign="end">
                                                                    <Stack horizontal tokens={stackTokens} verticalAlign="end">
                                                                        <Dropdown
                                                                            id="dditsec"
                                                                            placeHolder="--Select--"
                                                                            componentRef={dropdownRef} responsiveMode={ResponsiveMode.large}
                                                                            options={[
                                                                                { key: 'Yes', text: 'Yes' },
                                                                                { key: 'No', text: 'No' }
                                                                            ]}
                                                                            required={true}
                                                                            styles={{ dropdown: { minWidth: 100 } }}
                                                                            selectedKey={this.state.terms.itSec}
                                                                            onChanged={this.onChangeITSec.bind(this)}
                                                                            errorMessage={this.ITSecurityError}
                                                                        />
                                                                    </Stack>
                                                                </Stack>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={responsiveTableRow}>
                                            <div className={responsiveTableBodyCell}>
                                                <div className={responsiveTable}>
                                                    <div className={responsiveTableBody}>
                                                        <div className={responsiveTableRow}>
                                                            <div className={responsiveTableBodyCell}>If yes, which standard(s) does it comply with?</div>
                                                            <div className={responsiveTableBodyCell}>
                                                                <TextField className={textboxS} value={this.state.terms.itSecStd}
                                                                    maxLength={40} onChange={this.getErrorMessageITSecStd} errorMessage={this.ITSecurityStandardError} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={responsiveTableBodyCaption}>11.	CODE OF CONDUCT</div>
                                        <div className={responsiveTableRow}>
                                            <div className={responsiveTableBodyCell}>
                                                <div className={responsiveTable}>
                                                    <div className={responsiveTableBody}>
                                                        <div className={responsiveTableRow}>
                                                            <div className={responsiveTableBodyCell}>Are you bound to any code(s) of professional conduct?</div>
                                                            <div className={responsiveTableBodyCell}>
                                                                <Stack tokens={stackTokens} verticalAlign="end">
                                                                    <Stack horizontal tokens={stackTokens} verticalAlign="end">
                                                                        <Dropdown
                                                                            id="ddprofcon"
                                                                            placeHolder="--Select--"
                                                                            componentRef={dropdownRef} responsiveMode={ResponsiveMode.large}
                                                                            options={[
                                                                                { key: 'Yes', text: 'Yes' },
                                                                                { key: 'No', text: 'No' }
                                                                            ]}
                                                                            required={true}
                                                                            styles={{ dropdown: { minWidth: 100 } }}
                                                                            selectedKey={this.state.terms.profConduct}
                                                                            onChanged={this.onChangeProfCon.bind(this)}
                                                                            errorMessage={this.ProfessionalConductError}
                                                                        />
                                                                    </Stack>
                                                                </Stack>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={responsiveTableRow}>
                                            <div className={responsiveTableBodyCell}>
                                                <div className={responsiveTable}>
                                                    <div className={responsiveTableBody}>
                                                        <div className={responsiveTableRow}>
                                                            <div className={responsiveTableBodyCell}>If yes, please indicate which code(s).</div>
                                                            <div className={responsiveTableBodyCell}>
                                                                <TextField className={textboxS} value={this.state.terms.conductCodes}
                                                                    maxLength={40} onChange={this.getErrorMessageProfCon} errorMessage={this.ConductCodeError} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={responsiveTableBodyCaption}>12.	DOCKETING SYSTEM (IP MANAGEMENT TOOL)</div>
                                        <div className={responsiveTableRow}>
                                            <div className={responsiveTableBodyCell}>
                                                <div className={responsiveTable}>
                                                    <div className={responsiveTableBody}>
                                                        <div className={responsiveTableRow}>
                                                            <div className={responsiveTableBodyCell}>Which docketing system(s) do you use for case management?</div>
                                                            <div className={responsiveTableBodyCell}>
                                                                <TextField required className={textboxS} value={this.state.terms.docketingSystem}
                                                                    maxLength={40} onChange={this.getErrorMessageDockSys} errorMessage={this.DocketingSystemError} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={responsiveTableBodyCaption}>13.	ACCEPTANCE OF TERMS OF BUSINESS</div>
                                        <div className={responsiveTableRow}>
                                            <div className={responsiveTableBodyCell}>
                                                <div className={responsiveTable}>
                                                    <div className={responsiveTableBody}>
                                                        <div className={responsiveTableRow}>
                                                            <div className={responsiveTableBodyCell}>Please read and confirm our terms of business. <Link onClick={this.ExtraTerms}>Click here </Link> to read.</div>
                                                            <div className={responsiveTableBodyCell}>
                                                                <Stack tokens={stackTokens} verticalAlign="end">
                                                                    <Stack horizontal tokens={stackTokens} verticalAlign="end">
                                                                        <Dropdown
                                                                            id="ddbussterms"
                                                                            placeHolder="--Select--"
                                                                            componentRef={dropdownRef} responsiveMode={ResponsiveMode.large}
                                                                            options={[
                                                                                { key: 'Yes', text: 'Yes' },
                                                                                { key: 'No', text: 'No' }
                                                                            ]}
                                                                            required={true}
                                                                            styles={{ dropdown: { minWidth: 100 } }}
                                                                            onChanged={this.onChangeBussTerms.bind(this)}
                                                                            errorMessage={this.BussinessTermsError}
                                                                            selectedKey={this.state.terms.businessTerms}
                                                                        />
                                                                    </Stack>
                                                                </Stack>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={checkBoxTermsPanel}><input className={checkBoxTerms} type="checkbox" onChange={(event) => this.handleCheck(event)}
                                            checked={this.state.isTermsChecked} disabled={(this.state.terms.id !== null && this.state.terms.id !== "" && this.state.terms.id !== undefined)} />I have read and agree to the terms of business.</div>
                                        <div className={submitButtonAlignment}>
                                            <span className={alertMsgPanel}> * </span> Mandatory  <br />
                                            {
                                                (((this.state.terms.id !== null && this.state.terms.id !== "" && this.state.terms.id !== undefined) || (!this.state.isActive)) &&
                                                    <PrimaryButton type="submit" value="Submit" text="Submit" disabled iconProps={{ iconName: 'SaveAndClose' }} className={submitButton} />)
                                            }
                                            {
                                                (this.state.isActive &&
                                                    <PrimaryButton type="submit" value="Submit" text="Submit" onClick={this.submitForm} className={submitButton} iconProps={{ iconName: 'SaveAndClose' }} />)
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
            </div>
        );
    }
    private loadCurrencies(): void {
        this.setState((prevState: ITermsServicesState): ITermsServicesState => {
            var result: any = [];
            result.push(
                { key: 'AFN', text: 'AFN - Afghanistan Afghani' },
                { key: 'ALL', text: 'ALL - Albanian Lek' },
                { key: 'DZD', text: 'DZD - Algerian Dinar' },
                { key: 'USD', text: 'USD - US Dollar' },
                { key: 'EUR', text: 'EUR - Euro' },
                { key: 'AOA', text: 'AOA - Angolan Kwanza' },
                { key: 'XCD', text: 'XCD - East Caribbean Dollar' },
                { key: 'ARS', text: 'ARS - Argentine Peso' },
                { key: 'AMD', text: 'AMD - Armenian Dram' },
                { key: 'AWG', text: 'AWG - Aruban Guilder' },
                { key: 'AUD', text: 'AUD - Australian Dollar' },
                { key: 'AZN', text: 'AZN - Azerbaijan New Manat' },
                { key: 'BSD', text: 'BSD - Bahamian Dollar' },
                { key: 'BHD', text: 'BHD - Bahraini Dinar' },
                { key: 'BDT', text: 'BDT - Bangladeshi Taka' },
                { key: 'BBD', text: 'BBD - Barbados Dollar' },
                { key: 'BYR', text: 'BYR - Belarussian Ruble' },
                { key: 'BZD', text: 'BZD - Belize Dollar' },
                { key: 'XOF', text: 'XOF - CFA Franc BCEAO' },
                { key: 'BMD', text: 'BMD - Bermudian Dollar' },
                { key: 'BTN', text: 'BTN - Bhutan Ngultrum' },
                { key: 'BOB', text: 'BOB - Boliviano' },
                { key: 'BAM', text: 'BAM - Marka' },
                { key: 'BWP', text: 'BWP - Botswana Pula' },
                { key: 'NOK', text: 'NOK - Norwegian Krone' },
                { key: 'BRL', text: 'BRL - Brazilian Real' },
                { key: 'BND', text: 'BND - Brunei Dollar' },
                { key: 'BGN', text: 'BGN - Bulgarian Lev' },
                { key: 'BIF', text: 'BIF - Burundi Franc' },
                { key: 'CVE', text: 'CVE - Cape Verde Escudo' },
                { key: 'KHR', text: 'KHR - Kampuchean Riel' },
                { key: 'XAF', text: 'XAF - CFA Franc BEAC' },
                { key: 'CAD', text: 'CAD - Canadian Dollar' },
                { key: 'KYD', text: 'KYD - Cayman Islands Dollar' },
                { key: 'CLP', text: 'CLP - Chilean Peso' },
                { key: 'CNY', text: 'CNY - Yuan Renminbi' },
                { key: 'COP', text: 'COP - Colombian Peso' },
                { key: 'KMF', text: 'KMF - Comoros Franc' },
                { key: 'CDF', text: 'CDF - Francs' },
                { key: 'NZD', text: 'NZD - New Zealand Dollar' },
                { key: 'CRC', text: 'CRC - Costa Rican Colon' },
                { key: 'HRK', text: 'HRK - Croatian Kuna' },
                { key: 'CUP', text: 'CUP - Cuban Peso' },
                { key: 'CZK', text: 'CZK - Czech Koruna' },
                { key: 'DKK', text: 'DKK - Danish Krone' },
                { key: 'DJF', text: 'DJF - Djibouti Franc' },
                { key: 'DOP', text: 'DOP - Dominican Peso' },
                { key: 'ECS', text: 'ECS - Ecuador Sucre' },
                { key: 'EGP', text: 'EGP - Egyptian Pound' },
                { key: 'SVC', text: 'SVC - El Salvador Colon' },
                { key: 'ERN', text: 'ERN - Eritrean Nakfa' },
                { key: 'ETB', text: 'ETB - Ethiopian Birr' },
                { key: 'FKP', text: 'FKP - Falkland Islands Pound' },
                { key: 'FJD', text: 'FJD - Fiji Dollar' },
                { key: 'GMD', text: 'GMD - Gambian Dalasi' },
                { key: 'GEL', text: 'GEL - Georgian Lari' },
                { key: 'GHS', text: 'GHS - Ghanaian Cedi' },
                { key: 'GIP', text: 'GIP - Gibraltar Pound' },
                { key: 'GBP', text: 'GBP - Pound Sterling' },
                { key: 'XCD', text: 'XCD - East Carribean Dollar' },
                { key: 'QTQ', text: 'QTQ - Guatemalan Quetzal' },
                { key: 'GGP', text: 'GGP - Pound Sterling' },
                { key: 'GNF', text: 'GNF - Guinea Franc' },
                { key: 'GWP', text: 'GWP - Guinea-Bissau Peso' },
                { key: 'GYD', text: 'GYD - Guyana Dollar' },
                { key: 'HTG', text: 'HTG - Haitian Gourde' },
                { key: 'HNL', text: 'HNL - Honduran Lempira' },
                { key: 'HKD', text: 'HKD - Hong Kong Dollar' },
                { key: 'HUF', text: 'HUF - Hungarian Forint' },
                { key: 'ISK', text: 'ISK - Iceland Krona' },
                { key: 'INR', text: 'INR - Indian Rupee' },
                { key: 'IDR', text: 'IDR - Indonesian Rupiah' },
                { key: 'IRR', text: 'IRR - Iranian Rial' },
                { key: 'IQD', text: 'IQD - Iraqi Dinar' },
                { key: 'ILS', text: 'ILS - Israeli New Shekel' },
                { key: 'JMD', text: 'JMD - Jamaican Dollar' },
                { key: 'JPY', text: 'JPY - Japanese Yen' },
                { key: 'JOD', text: 'JOD - Jordanian Dinar' },
                { key: 'KZT', text: 'KZT - Kazakhstan Tenge' },
                { key: 'KES', text: 'KES - Kenyan Shilling' },
                { key: 'KPW', text: 'KPW - North Korean Won' },
                { key: 'KRW', text: 'KRW - Korean Won' },
                { key: 'KWD', text: 'KWD - Kuwaiti Dinar' },
                { key: 'KGS', text: 'KGS - Som' },
                { key: 'LAK', text: 'LAK - Lao Kip' },
                { key: 'LVL', text: 'LVL - Latvian Lats' },
                { key: 'LBP', text: 'LBP - Lebanese Pound' },
                { key: 'LSL', text: 'LSL - Lesotho Loti' },
                { key: 'LRD', text: 'LRD - Liberian Dollar' },
                { key: 'LYD', text: 'LYD - Libyan Dinar' },
                { key: 'CHF', text: 'CHF - Swiss Franc' },
                { key: 'LTL', text: 'LTL - Lithuanian Litas' },
                { key: 'MOP', text: 'MOP - Macau Pataca' },
                { key: 'MKD', text: 'MKD - Denar' },
                { key: 'MGF', text: 'MGF - Malagasy Franc' },
                { key: 'MWK', text: 'MWK - Malawi Kwacha' },
                { key: 'MYR', text: 'MYR - Malaysian Ringgit' },
                { key: 'MVR', text: 'MVR - Maldive Rufiyaa' },
                { key: 'MRO', text: 'MRO - Mauritanian Ouguiya' },
                { key: 'MUR', text: 'MUR - Mauritius Rupee' },
                { key: 'MXN', text: 'MXN - Mexican Nuevo Peso' },
                { key: 'MDL', text: 'MDL - Moldovan Leu' },
                { key: 'MNT', text: 'MNT - Mongolian Tugrik' },
                { key: 'MAD', text: 'MAD - Moroccan Dirham' },
                { key: 'MZN', text: 'MZN - Mozambique Metical' },
                { key: 'MMK', text: 'MMK - Myanmar Kyat' },
                { key: 'NAD', text: 'NAD - Namibian Dollar' },
                { key: 'NPR', text: 'NPR - Nepalese Rupee' },
                { key: 'ANG', text: 'ANG - Netherlands Antillean Guilder' },
                { key: 'XPF', text: 'XPF - CFP Franc' },
                { key: 'NIO', text: 'NIO - Nicaraguan Cordoba Oro' },
                { key: 'NGN', text: 'NGN - Nigerian Naira' },
                { key: 'OMR', text: 'OMR - Omani Rial' },
                { key: 'PKR', text: 'PKR - Pakistan Rupee' },
                { key: 'PAB', text: 'PAB - Panamanian Balboa' },
                { key: 'PGK', text: 'PGK - Papua New Guinea Kina' },
                { key: 'PYG', text: 'PYG - Paraguay Guarani' },
                { key: 'PEN', text: 'PEN - Peruvian Nuevo Sol' },
                { key: 'PHP', text: 'PHP - Philippine Peso' },
                { key: 'PLN', text: 'PLN - Polish Zloty' },
                { key: 'QAR', text: 'QAR - Qatari Rial' },
                { key: 'RON', text: 'RON - Romanian New Leu' },
                { key: 'RUB', text: 'RUB - Russian Ruble' },
                { key: 'RWF', text: 'RWF - Rwanda Franc' },
                { key: 'SHP', text: 'SHP - St. Helena Pound' },
                { key: 'WST', text: 'WST - Samoan Tala' },
                { key: 'STD', text: 'STD - Dobra' },
                { key: 'SAR', text: 'SAR - Saudi Riyal' },
                { key: 'RSD', text: 'RSD - Dinar' },
                { key: 'SCR', text: 'SCR - Seychelles Rupee' },
                { key: 'SLL', text: 'SLL - Sierra Leone Leone' },
                { key: 'SGD', text: 'SGD - Singapore Dollar' },
                { key: 'SBD', text: 'SBD - Solomon Islands Dollar' },
                { key: 'SOS', text: 'SOS - Somali Shilling' },
                { key: 'ZAR', text: 'ZAR - South African Rand' },
                { key: 'SSP', text: 'SSP - South Sudan Pound' },
                { key: 'LKR', text: 'LKR - Sri Lanka Rupee' },
                { key: 'SDG', text: 'SDG - Sudanese Pound' },
                { key: 'SRD', text: 'SRD - Surinam Dollar' },
                { key: 'SZL', text: 'SZL - Swaziland Lilangeni' },
                { key: 'SEK', text: 'SEK - Swedish Krona' },
                { key: 'SYP', text: 'SYP - Syrian Pound' },
                { key: 'TWD', text: 'TWD - Taiwan Dollar' },
                { key: 'TJS', text: 'TJS - Tajik Somoni' },
                { key: 'TZS', text: 'TZS - Tanzanian Shilling' },
                { key: 'THB', text: 'THB - Thai Baht' },
                { key: 'TOP', text: "TOP - Tongan Pa'anga" },
                { key: 'TTD', text: 'TTD - Trinidad and Tobago Dollar' },
                { key: 'TND', text: 'TND - Tunisian Dollar' },
                { key: 'TRY', text: 'TRY - Turkish Lira' },
                { key: 'TMT', text: 'TMT - Manat' },
                { key: 'UGX', text: 'UGX - Uganda Shilling' },
                { key: 'UAH', text: 'UAH - Ukraine Hryvnia' },
                { key: 'AED', text: 'AED - Arab Emirates Dirham' },
                { key: 'UYU', text: 'UYU - Uruguayan Peso' },
                { key: 'UZS', text: 'UZS - Uzbekistan Sum' },
                { key: 'VUV', text: 'VUV - Vanuatu Vatu' },
                { key: 'VEF', text: 'VEF - Venezuelan Bolivar' },
                { key: 'VND', text: 'VND - Vietnamese Dong' },
                { key: 'YER', text: 'YER - Yemeni Rial' },
                { key: 'ZMW', text: 'ZMW - Zambian Kwacha' },
                { key: 'ZWD', text: 'ZWD - Zimbabwe Dollar' }
            );
            prevState.Currencies = result;
            return prevState;
        });
    }
    private submitForm = async (): Promise<void> => {
        if (this.checkMandatoryFields()) {
            try {
                await this.props.connectionContext.post("Terms", this.state.terms)
                this.setState((prevState: ITermsServicesState): ITermsServicesState => {
                    prevState.saving = true;
                    prevState.isValidData = true;
                    this.handleError("Success", "Thank you for accepting the terms of services. Please proceed to add your charges for the selected jurisdiction(s).");
                    return prevState;
                });
            } catch (exception) {
                this.setState((prevState: ITermsServicesState): ITermsServicesState => {
                    prevState.saving = true;
                    prevState.isValidData = false;
                    this.handleError("Message", "Unable to process at the moment. Please try again or contact agent.network@zacco.com.");
                    return prevState;
                });
            }
        }
    }
    private checkMandatoryFields(): boolean {
        let validState: boolean = true;
        let employees: boolean = this.state.terms.employees.toString().trim().length > 0;
        let patentAttorneys: boolean = this.state.terms.patentAttorneys.toString().trim().length > 0;
        let trademarkAttorneys: boolean = this.state.terms.trademarkAttorneys.toString().trim().length > 0;
        let lawAttorneys: boolean = this.state.terms.lawAttorneys.toString().trim().length > 0;
        let rPALastYear: boolean = this.state.terms.rpaLastYear.toString().trim().length > 0;
        let pAPCTLastYear: boolean = this.state.terms.papctLastYear.toString().trim().length > 0;
        let rTALastYear: boolean = this.state.terms.rtaLastYear.toString().trim().length > 0;
        let tAMALastYear: boolean = this.state.terms.tamaLastYear.toString().trim().length > 0;
        let tradeProsecRank: boolean = this.state.terms.tradeProsecRank.toString().trim().length > 0;
        let patentProsecRank: boolean = this.state.terms.patentProsecRank.toString().trim().length > 0;
        let anyOtherAward: boolean = this.state.terms.anyOtherAward.toString().trim().length > 0;
        let indemnityInsurance: boolean = this.state.terms.indemnityInsurance.toString().trim().length > 0;
        let iMaxAmount: boolean = this.state.terms.iMaxAmount.toString().trim().length > 0;
        let iCurrency: boolean = this.state.terms.iCurrency.toString().trim().length > 0;
        let iAnnualAggregate: boolean = this.state.terms.iAnnualAggregate.toString().trim().length > 0;
        let aACurrency: boolean = this.state.terms.aaCurrency.toString().trim().length > 0;
        let technicalCompetenceAgent: boolean = this.state.terms.technicalCompetenceAgent.length > 0;
        let ptoName: boolean = this.state.ptonames.length > 0;
        this.state.ptonames.forEach((item: IPTONames) => {
            if (item.ptoName === "" || item.ptoName === undefined || item.ptoName === null) {
                ptoName = false;
            }
        });
        let qtyMgmt: boolean = this.state.terms.qtyMgmt.toString().trim().length > 0;
        let qtyMgmtStd: boolean = this.state.terms.qtyMgmtStd.toString().trim().length > 0;
        let iTSec: boolean = this.state.terms.itSec.toString().trim().length > 0;
        let iTSecStd: boolean = this.state.terms.itSecStd.toString().trim().length > 0;
        let profConduct: boolean = this.state.terms.profConduct.toString().trim().length > 0;
        let conductCodes: boolean = this.state.terms.conductCodes.toString().trim().length > 0;
        let docketingSystem: boolean = this.state.terms.docketingSystem.toString().trim().length > 0;

        if (!employees) {
            this.EmployeeError = 'Required';
            validState = false;
        }

        if (!patentAttorneys) {
            this.PatentAttorneyError = 'Required';
            validState = false;
        }

        if (!trademarkAttorneys) {
            this.TrademarkAttorneyError = 'Required';
            validState = false;
        }
        if (!lawAttorneys) {
            this.LawAttorneyError = 'Required';
            validState = false;
        }
        if (!rPALastYear) {
            this.ResidentPatentError = 'Required';
            validState = false;
        }

        if (!pAPCTLastYear) {
            this.PatentApplicationError = 'Required';
            validState = false;
        }
        if (!rTALastYear) {
            this.ResidentTrademarkError = 'Required';
            validState = false;
        }
        if (!tAMALastYear) {
            this.TrademarkapplicationsError = 'Required';
            validState = false;
        }
        if (!tradeProsecRank) {
            this.TrademarkProsecutionError = 'Required';
            validState = false;
        }
        if (!patentProsecRank) {
            this.PatentProsecutionError = 'Required';
            validState = false;
        }
        if (!anyOtherAward) {
            this.RewardError = 'Required';
            validState = false;
        }
        if (!indemnityInsurance) {
            this.InsuranceError = 'Required';
            validState = false;
        }
        else {
            if (this.state.terms.indemnityInsurance === "Yes") {
                if (!iMaxAmount) {
                    this.InsuranceAmountError = 'Required';
                    validState = false;
                }
                if (!iCurrency) {
                    this.InsuranceCurrencyError = 'Required';
                    validState = false;
                }
                if (!iAnnualAggregate) {
                    this.AnnualAggregateError = 'Required';
                    validState = false;
                }
                if (!aACurrency) {
                    this.AnnualAggregateCurrencyError = 'Required';
                    validState = false;
                }
            }
        }
        if (!technicalCompetenceAgent) {
            this.TechnicalCompetenceError = 'Required';
            validState = false;
        }

        if (!ptoName) {
            this.PTOError = 'Required';
            validState = false;
        }

        if (!qtyMgmt) {
            this.QtyManagementError = 'Required';
            validState = false;
        }
        else {
            if (this.state.terms.qtyMgmt.toString() === "Yes" && !qtyMgmtStd) {
                this.QtyManagementStandardError = 'Required';
                validState = false;
            }
            else {
                this.QtyManagementStandardError = '';
            }
        }

        if (!iTSec) {
            this.ITSecurityError = 'Required';
            validState = false;
        }
        else {
            if (this.state.terms.itSec.toString() === "Yes" && !iTSecStd) {
                this.ITSecurityStandardError = 'Required';
                validState = false;
            }
            else {
                this.ITSecurityStandardError = '';
            }
        }

        if (!profConduct) {
            this.ProfessionalConductError = 'Required';
            validState = false;
        }
        else {
            if (this.state.terms.profConduct.toString() === "Yes" && !conductCodes) {
                this.ConductCodeError = 'Required';
                validState = false;
            }
            else {
                this.ConductCodeError = '';
            }
        }
        if (!docketingSystem) {
            this.DocketingSystemError = 'Required';
            validState = false;
        }
        this.setState((prevState: ITermsServicesState): ITermsServicesState => {
            prevState.isValidData = validState;
            return prevState;
        });
        return validState;
    }
    private handleError(message: string, body: string) {
        this.dialog.dialogMessage = message;
        this.dialog.dialogBody = body;
        this.dialog.accessDeniedDialog = false;
        this.dialog.hideDialog = false;
        this.setState((previousState: ITermsServicesState, props: ITermsServicesProps): ITermsServicesState => {
            previousState.hideDialog = false;
            return previousState;
        });
    }
    private acceptBusinessTerms = (): void => {
        this.setState((previousState: ITermsServicesState): ITermsServicesState => {
            previousState.hideDialog = true;
            previousState.hideModel = true;
            previousState.isValidData = false;
            previousState.saving = false;
            previousState.terms.businessTerms = 'Yes';
            previousState.isBussChecked = true;
            previousState.isTermsChecked = true;
            previousState.terms.serviceTerms = true;
            if (this.state.isTermsChecked && this.state.isBussChecked) {
                previousState.isActive = true;
            }
            else {
                previousState.isActive = false;
            }
            return previousState;
        });
    }
    private declineBusinessTerms = (): void => {
        this.setState((previousState: ITermsServicesState): ITermsServicesState => {
            previousState.hideDialog = true;
            previousState.hideModel = true;
            previousState.isValidData = false;
            previousState.saving = false;
            return previousState;
        });
    }
    private closeMessagePopup = (): void => {
        this.setState((previousState: ITermsServicesState): ITermsServicesState => {
            previousState.hideDialog = true;
            previousState.hideModel = true;
            previousState.isValidData = false;
            previousState.saving = false;
            this.props.isAuthenticated();
            return previousState;
        });
    }
    private getErrorMessageEmp = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, value?: string) => {
        this.setState((prevState: ITermsServicesState): ITermsServicesState => {
            let newValue = value || '';
            const re1 = /^[0-9]+$/;
            if (newValue.length < 1) {
                this.EmployeeError = 'Number of employees is required.';
                prevState.terms.employees = 0;
            }
            else if (!re1.test(newValue)) {
                ev.preventDefault();
                this.EmployeeError = 'Only numerals allowed';
            }
            else {
                this.EmployeeError = '';
                prevState.terms.employees = parseInt(newValue);
            }
            return prevState;
        });
    }
    private getErrorMessagePA = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, value?: string) => {
        this.setState((prevState: ITermsServicesState): ITermsServicesState => {
            let newValue = value || '';
            const re1 = /^[0-9]+$/;
            if (newValue.length < 1) {
                this.PatentAttorneyError = 'Number of patent attorneys/agents is required.';
                prevState.terms.patentAttorneys = 0;
            }
            else if (!re1.test(newValue)) {
                ev.preventDefault();
                this.PatentAttorneyError = 'Only numerals allowed';
            }
            else {
                this.PatentAttorneyError = '';
                prevState.terms.patentAttorneys = parseInt(newValue);
            }
            return prevState;
        });
    }
    private getErrorMessageTA = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, value?: string) => {
        this.setState((prevState: ITermsServicesState): ITermsServicesState => {
            let newValue = value || '';
            const re1 = /^[0-9]+$/;
            if (newValue.length < 1) {
                this.TrademarkAttorneyError = 'Number of trademark attorneys/agents is required.';
                prevState.terms.trademarkAttorneys = 0;
            }
            else if (!re1.test(newValue)) {
                ev.preventDefault();
                this.TrademarkAttorneyError = 'Only numerals allowed';
            }
            else {
                this.TrademarkAttorneyError = '';
                prevState.terms.trademarkAttorneys = parseInt(newValue);
            }
            return prevState;
        });
    }
    private getErrorMessageLA = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, value?: string) => {
        this.setState((prevState: ITermsServicesState): ITermsServicesState => {
            let newValue = value || '';
            const re1 = /^[0-9]+$/;
            if (newValue.length < 1) {
                this.LawAttorneyError = 'Number of attorneys at law is required.';
                prevState.terms.lawAttorneys = 0;
            }
            else if (!re1.test(newValue)) {
                this.LawAttorneyError = 'Only numerals allowed';
            }
            else {
                this.LawAttorneyError = '';
                prevState.terms.lawAttorneys = parseInt(newValue);
            }
            return prevState;
        });
    }
    private getErrorMessageRPA = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, value?: string) => {
        this.setState((prevState: ITermsServicesState): ITermsServicesState => {
            let newValue = value || '';
            const re1 = /^[0-9]+$/;
            if (newValue.length < 1) {
                this.ResidentPatentError = 'Resident patent applications filed last year is required.';
                prevState.terms.rpaLastYear = 0;
            }
            else if (!re1.test(newValue)) {
                this.ResidentPatentError = 'Only numerals allowed';
            }
            else {
                this.ResidentPatentError = '';
                prevState.terms.rpaLastYear = parseInt(newValue);
            }
            return prevState;
        });
    }
    private getErrorMessagePAPCT = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, value?: string) => {
        this.setState((prevState: ITermsServicesState): ITermsServicesState => {
            let newValue = value || '';
            const re1 = /^[0-9]+$/;
            if (newValue.length < 1) {
                this.PatentApplicationError = 'Patent applications filed under the PCT last year is required.';
                prevState.terms.papctLastYear = 0;
            }
            else if (!re1.test(newValue)) {
                this.PatentApplicationError = 'Only numerals allowed';
            }
            else {
                this.PatentApplicationError = '';
                prevState.terms.papctLastYear = parseInt(newValue);
            }
            return prevState;
        });
    }
    private getErrorMessageRTA = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, value?: string) => {
        this.setState((prevState: ITermsServicesState): ITermsServicesState => {
            let newValue = value || '';
            const re1 = /^[0-9]+$/;
            if (newValue.length < 1) {
                this.ResidentTrademarkError = 'Resident trademark applications filed last year is required.';
                prevState.terms.rtaLastYear = 0;
            }
            else if (!re1.test(newValue)) {
                this.ResidentTrademarkError = 'Only numerals allowed';
            }
            else {
                this.ResidentTrademarkError = '';
                prevState.terms.rtaLastYear = parseInt(newValue);
            }
            return prevState;
        });
    }
    private getErrorMessageTAMA = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, value?: string) => {
        this.setState((prevState: ITermsServicesState): ITermsServicesState => {
            let newValue = value || '';
            const re1 = /^[0-9]+$/;
            if (newValue.length < 1) {
                this.TrademarkapplicationsError = 'Trademark applications filed under the Madrid Agreement last year is required.';
                prevState.terms.tamaLastYear = 0;
            }
            else if (!re1.test(newValue)) {
                this.TrademarkapplicationsError = 'Only numerals allowed';
            }
            else {
                this.TrademarkapplicationsError = '';
                prevState.terms.tamaLastYear = parseInt(newValue);
            }
            return prevState;
        });
    }
    private getErrorMessageTrPr = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, value?: string) => {
        this.setState((prevState: ITermsServicesState): ITermsServicesState => {
            let newValue = value || '';
            const re1 = /^[0-9]+$/;
            if (newValue.length < 1) {
                this.TrademarkProsecutionError = 'Trademark prosecution ranking is required.';
                prevState.terms.tradeProsecRank = 0;
            }
            else if (!re1.test(newValue)) {
                this.TrademarkProsecutionError = 'Only numerals allowed';
            }
            else {
                this.TrademarkProsecutionError = '';
                prevState.terms.tradeProsecRank = parseInt(newValue);
            }
            return prevState;
        });
    }
    private getErrorMessagePPtPr = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, value?: string) => {
        this.setState((prevState: ITermsServicesState): ITermsServicesState => {
            let newValue = value || '';
            const re1 = /^[0-9]+$/;
            if (newValue.length < 1) {
                this.PatentProsecutionError = 'Patent prosecution ranking is required.';
                prevState.terms.patentProsecRank = 0;
            }
            else if (!re1.test(newValue)) {
                this.PatentProsecutionError = 'Only numerals allowed';
            }
            else {
                this.PatentProsecutionError = '';
                prevState.terms.patentProsecRank = parseInt(newValue);
            }
            return prevState;
        });
    }
    private onChangeReward(item: IDropdownOption) {
        this.setState((prevState: ITermsServicesState): ITermsServicesState => {
            prevState.terms.anyOtherAward = item.text;
            this.RewardError = item.text.trim().length > 0 ? '' : 'Select Yes or No';
            return prevState;
        });
    }
    private onChangeIns(item: IDropdownOption) {
        this.setState((prevState: ITermsServicesState): ITermsServicesState => {
            prevState.terms.indemnityInsurance = item.text;
            this.InsuranceError = item.text.trim().length > 0 ? '' : 'Select Yes or No';
            return prevState;
        });
    }
    private getErrorMessageInsAmt = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, value?: string) => {
        this.setState((prevState: ITermsServicesState): ITermsServicesState => {
            const re = /^[0-9]\d*(\.\d+)?$/;
            let newValue = value || '';
            if (newValue.length < 1) {
                this.InsuranceAmountError = 'Indicate maximum amount and currency per claim';
                prevState.terms.iMaxAmount = 0;
            }
            else if (!re.test(newValue)) {
                ev.preventDefault();
                this.InsuranceAmountError = 'Only numerals allowed';
            }
            else {
                this.InsuranceAmountError = '';
                prevState.terms.iMaxAmount = parseFloat(newValue);
            }
            return prevState;
        });
    }
    private onChangeInsCur: IComboBoxProps['onChange'] = (event, option): void => {
        this.setState((prevState: ITermsServicesState): ITermsServicesState => {
            if (option) {
                prevState.terms.iCurrency = option.key.toString();
                this.InsuranceCurrencyError = option.text.trim().length > 0 ? '' : 'Select any currency';
            }
            return prevState;
        });
    }
    private getErrorMessageAAmt = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, value?: string) => {
        this.setState((prevState: ITermsServicesState): ITermsServicesState => {
            const re = /^[0-9]\d*(\.\d+)?$/;
            let newValue = value || '';
            if (newValue.length < 1) {
                this.AnnualAggregateError = 'Annual aggregate is required';
                prevState.terms.iAnnualAggregate = 0;
            }
            else if (!re.test(newValue)) {
                ev.preventDefault();
                this.AnnualAggregateError = 'Only numerals allowed';
            }
            else {
                this.AnnualAggregateError = '';
                prevState.terms.iAnnualAggregate = parseFloat(newValue);
            }
            return prevState;
        });
    }
    private onChangeAACur: IComboBoxProps['onChange'] = (event, option): void => {
        this.setState((prevState: ITermsServicesState): ITermsServicesState => {
            if (option) {
                prevState.terms.aaCurrency = option.key.toString();
                this.AnnualAggregateError = option.text.trim().length > 0 ? '' : 'Select any currency';
            }
            return prevState;
        });
    }
    private onChangeQtyMgmt(item: IDropdownOption) {
        this.setState((prevState: ITermsServicesState): ITermsServicesState => {
            prevState.terms.qtyMgmt = item.text;
            this.QtyManagementError = item.text.trim().length > 0 ? '' : 'Select Yes or No';
            if (prevState.terms.qtyMgmt.toString() === "Yes" && prevState.terms.qtyMgmtStd.length < 1) {
                this.QtyManagementStandardError = 'Required';
            }
            else {
                this.QtyManagementStandardError = '';
            }
            return prevState;
        });
    }
    private onChangeITSec(item: IDropdownOption) {
        this.setState((prevState: ITermsServicesState): ITermsServicesState => {
            prevState.terms.itSec = item.text;
            this.ITSecurityError = item.text.trim().length > 0 ? '' : 'Select Yes or No';
            if (prevState.terms.itSec.toString() === "Yes" && prevState.terms.itSecStd.length < 1) {
                this.ITSecurityStandardError = 'Required';
            }
            else {
                this.ITSecurityStandardError = '';
            }
            return prevState;
        });
    }
    private onChangeProfCon(item: IDropdownOption) {
        this.setState((prevState: ITermsServicesState): ITermsServicesState => {
            prevState.terms.profConduct = item.text;
            this.ProfessionalConductError = item.text.trim().length > 0 ? '' : 'Select Yes or No';
            if (prevState.terms.profConduct.toString() === "Yes" && prevState.terms.conductCodes.length < 1) {
                this.ConductCodeError = 'Required';
            }
            else {
                this.ConductCodeError = '';
            }
            return prevState;
        });
    }
    private onChangeBussTerms(item: IDropdownOption) {
        this.setState((prevState: ITermsServicesState): ITermsServicesState => {
            prevState.terms.businessTerms = item.text;
            if (item.text === 'Yes') {
                prevState.isBussChecked = true;
            }
            else {
                prevState.isBussChecked = false;
            }
            if (this.state.isTermsChecked && this.state.isBussChecked) {
                prevState.isActive = true;
            }
            else {
                prevState.isActive = false;
            }
            this.BussinessTermsError = item.text.trim().length > 0 ? '' : 'Select Yes or No';
            return prevState;
        });
    }
    private getErrorMessageQtyMgmtStd = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, value?: string) => {
        this.setState((prevState: ITermsServicesState): ITermsServicesState => {
            const re = /^[a-zA-Z0-9 \b]+$/;
            let newValue = value || '';
            if (newValue.length < 1) {
                this.QtyManagementStandardError = 'Required.';
                prevState.terms.qtyMgmtStd = '';
            }
            else if (!re.test(newValue)) {
                ev.preventDefault();
                this.QtyManagementStandardError = '';
            }
            else {
                this.QtyManagementStandardError = '';
                prevState.terms.qtyMgmtStd = newValue.toUpperCase();
            }
            return prevState;
        });
    }
    private getErrorMessageITSecStd = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, value?: string) => {
        this.setState((prevState: ITermsServicesState): ITermsServicesState => {
            const re = /^[a-zA-Z0-9 \b]+$/;
            let newValue = value || '';
            if (newValue.length < 1) {
                this.ITSecurityStandardError = 'Required.';
                prevState.terms.itSecStd = '';
            }
            else if (!re.test(newValue)) {
                ev.preventDefault();
                this.ITSecurityStandardError = '';
            }
            else {
                this.ITSecurityStandardError = '';
                prevState.terms.itSecStd = newValue.toUpperCase();
            }
            return prevState;
        });
    }
    private getErrorMessageProfCon = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, value?: string) => {
        this.setState((prevState: ITermsServicesState): ITermsServicesState => {
            const re = /^[a-zA-Z0-9 \b]+$/;
            let newValue = value || '';
            if (newValue.length < 1) {
                this.ConductCodeError = 'Required.';
                prevState.terms.conductCodes = '';
            }
            else if (!re.test(newValue)) {
                ev.preventDefault();
                this.ConductCodeError = '';
            }
            else {
                this.ConductCodeError = '';
                prevState.terms.conductCodes = newValue.toUpperCase();
            }
            return prevState;
        });
    }
    private getErrorMessageDockSys = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, value?: string) => {
        this.setState((prevState: ITermsServicesState): ITermsServicesState => {
            const re = /^[a-zA-Z0-9 \b]+$/;
            let newValue = value || '';
            if (newValue.length < 1) {
                this.DocketingSystemError = 'Required.';
                prevState.terms.docketingSystem = '';
            }
            else if (!re.test(newValue)) {
                ev.preventDefault();
                this.DocketingSystemError = '';
            }
            else {
                this.DocketingSystemError = '';
                prevState.terms.docketingSystem = newValue.toUpperCase();
            }
            return prevState;
        });
    }
}
